import axios from "axios";
import { useState, useEffect } from "react";
import { ISettings } from "./uesSettings.types";

let tmp_settings_var;

if (typeof tmp_settings === "undefined") {
    tmp_settings_var = {};
} else {
    tmp_settings_var = tmp_settings;
}

let tmpCachedGlobalSettings = tmp_settings_var as ISettings;
let tmpGlobalSettings = tmp_settings_var as ISettings;
const listeners = new Set();

let tmpGlobalSettingsLoading: boolean = true;
const tmpGlobalSettingsLoadingListeners = new Set();

export const setCachedGlobalSettings = (nextGlobalState) => {
    tmpCachedGlobalSettings = nextGlobalState;
};

export const setGlobalSettings = (nextGlobalState) => {
    tmpGlobalSettings = nextGlobalState;
    listeners.forEach((listener: any) => listener());
};

export const setSettingsLoading = (nextGlobalState: boolean) => {
    tmpGlobalSettingsLoading = nextGlobalState;
    tmpGlobalSettingsLoadingListeners.forEach((listener: any) => listener());
};

export default function useSettings() {
    const [state, setState] = useState<ISettings>(tmpCachedGlobalSettings);

    setTimeout(() => {
        setState(tmpGlobalSettings);
    }, 0);

    useEffect(() => {
        const listener = () => {
            setState(tmpGlobalSettings);
        };

        listeners.add(listener);
        listener();

        return () => {
            listeners.delete(listener);
        };
    }, []);

    return state;
}

export function useSettingsLoading() {
    const [state, setState] = useState(tmpGlobalSettingsLoading);

    useEffect(() => {
        const listener = () => {
            setState(tmpGlobalSettingsLoading);
        };

        tmpGlobalSettingsLoadingListeners.add(listener);
        listener();

        return () => {
            tmpGlobalSettingsLoadingListeners.delete(listener);
        };
    }, []);

    return state;
}

if (typeof document !== "undefined" && typeof window !== "undefined") {
    const loadSettings = function () {
        if (typeof jQuery !== "undefined") {
            jQuery("body").on("click", function (e) {
                const target = jQuery(e.target).closest(".tmp-dealer-menu-login-item");

                jQuery(".tmp-dealer-menu-login-item")
                    .not(target)
                    .find(".tmp-dealer-menu-sub-menu")
                    .removeClass("tmp-active");

                const linkRoot = jQuery(".tmp-dealer-menu-login-item").filter(function () {
                    const t = jQuery(this);

                    return t.is(target) || t.has(target[0]).length > 0;
                });
                if (
                    linkRoot.length > 0 &&
                    jQuery(e.target).closest(".tmp-dealer-menu-sub-menu").length <= 0
                ) {
                    e.preventDefault();

                    const menu = linkRoot.find("> .tmp-dealer-menu-sub-menu");
                    if (menu.hasClass("tmp-active")) {
                        menu.removeClass("tmp-active");
                    } else {
                        menu.addClass("tmp-active");
                    }
                }
            });
            /*jQuery("body").on(
                "click",
                ".tmp-dealer-menu-login-item > .e-n-menu-title-container",
                function (e) {
                    const t = jQuery(this);
                    const linkRoot = t.closest(".tmp-dealer-menu-login-item");
                    e.preventDefault();

                    const menu = linkRoot.find("> .tmp-dealer-menu-sub-menu");
                    if (menu.hasClass("tmp-active")) {
                        menu.removeClass("tmp-active");
                    } else {
                        menu.addClass("tmp-active");
                    }
                }
            );*/
        }

        axios
            .get("/wp-content/plugins/tmp/api/settings.php")
            .then((response) => {
                setGlobalSettings(Object.assign({}, tmpGlobalSettings, response.data));

                if (typeof jQuery !== "undefined") {
                    jQuery(() => {
                        jQuery("body").trigger("init_settings", response);

                        if (response.data?.logged_in) {
                            document.body.classList.add("tmp-logged-in");
                            jQuery(".tmp-menu-login > a")
                                .attr("href", "/dealer")
                                .each(function () {
                                    const t = jQuery(this);
                                    const children = t.children();
                                    t.text("Konto").append(children);
                                });
                            if (response.data?.user_displayname) {
                                jQuery(".tmp-menu-login:not(.tmp-menu-login__parsed)").each(
                                    function () {
                                        const t = jQuery(this);
                                        t.addClass("tmp-menu-login__parsed");
                                        t.find(" > ul")
                                            .prepend(
                                                '<li class="menu-item menu-item-type-post_type menu-item-object-page nav-item elementskit-mobile-builder-content"><a href="/dealer" class="dropdown-item">' +
                                                    response.data.user_displayname +
                                                    "</a></li>"
                                            )
                                            .append(
                                                '<li class="menu-item menu-item-type-post_type menu-item-object-page nav-item elementskit-mobile-builder-content"><a href="?action=tmp_logout" class="dropdown-item">Logout</a></li>'
                                            );
                                    }
                                );
                            }

                            if (
                                response.data?.dealer_menu &&
                                response.data?.dealer_menu instanceof Array
                            ) {
                                jQuery(".e-n-menu").each(function () {
                                    const menuRoot = jQuery(this);
                                    const linkItem = menuRoot.find(
                                        '.e-n-menu-title-container a[href="/dealer/login"]'
                                    );
                                    const loginItem = linkItem.closest(".e-n-menu-title");
                                    linkItem.removeAttr("href").text("Konto");

                                    let elements = `
                                        <ul class="tmp-dealer-menu-sub-menu">
                                            <li>
                                                <a class="e-n-menu-title e-normal" href="/dealer">
                                                    <span class="e-n-menu-title-text">${response.data.user_displayname}</span>
                                                </a>
                                            </li>`;
                                    for (const menuItem of response.data?.dealer_menu) {
                                        elements += `
                                        <li>
                                            <a class="e-n-menu-title e-normal" href="${menuItem.url}" target="${menuItem.target}">
                                                <span class="e-n-menu-title-text">${menuItem.title}</span>
                                            </a>
                                        </li>
                                        `;
                                    }
                                    elements += "</ul>";

                                    loginItem
                                        .addClass("tmp-dealer-menu-login-item")
                                        .append(elements);
                                });
                            }
                        }
                    });
                }
            })
            .finally(() => {
                setSettingsLoading(false);
                if (typeof jQuery !== "undefined") {
                    jQuery(".tmp-menu-login").addClass("tmp-menu-login-loaded");
                }
            });
    };

    if (document.readyState === "complete") {
        loadSettings();
    } else {
        window.addEventListener("load", loadSettings);
    }
}
